const InvisvIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="svg5"
      version="1.1"
      viewBox="0 0 135.46668 135.46668"
      height="512"
      width="512"
    >
      <defs id="defs2" />
      <g transform="translate(-80.545724,-34.077336)" id="layer1">
        <path
          d="m 388.66662,366.79427 -125.25949,72.3186 -125.25948,-72.3186 0,-144.63719 125.25949,-72.31859 125.25948,72.31859 z"
          transform="matrix(0.43404741,0,0,0.43404741,33.947873,-26.005736)"
          id="path846-9"
          style={{
            fill: "none",
            fillRule: "evenodd",
            stroke: "#ffffff",
            strokeWidth: 14.62973826,
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
        />
        <path
          d="m 388.66662,366.79427 -125.25949,72.3186 -125.25948,-72.3186 0,-144.63719 125.25949,-72.31859 125.25948,72.31859 z"
          transform="matrix(0.21702371,0,0,0.21702371,91.113463,37.902465)"
          id="path846-9-6"
          style={{
            fill: "none",
            fillRule: "evenodd",
            stroke: "#ffffff",
            strokeWidth: 9.75315861,
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
        />
        <path
          d="m 388.66662,366.79427 -125.25949,72.3186 -125.25948,-72.3186 0,-144.63719 125.25949,-72.31859 125.25948,72.31859 z"
          transform="matrix(0.10851186,0,0,0.10851186,119.69626,69.856567)"
          id="path846-9-3"
          style={{
            fill: "none",
            fillRule: "evenodd",
            stroke: "#ffffff",
            strokeWidth: 9.75315816,
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
        />
        <path
          d="m 388.66662,366.79427 -125.25949,72.3186 -125.25948,-72.3186 0,-144.63719 125.25949,-72.31859 125.25948,72.31859 z"
          transform="matrix(0.32553557,0,0,0.32553557,62.530667,5.9483629)"
          id="path846-9-7"
          style={{
            fill: "none",
            fillRule: "evenodd",
            stroke: "#ffffff",
            strokeWidth: 13.00421129,
            strokeMiterlimit: 4,
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
        />
      </g>
    </svg>
  );
};

export default InvisvIcon;
